import React, { useState } from "react";
import { Button, Form, Card } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function CloudinarySimpleUpload() {
  const [file, setFile] = useState(null);
  const [uploadedUrl, setUploadedUrl] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
    const sendEmail = () => {

    navigate("/admin-send-art-link");
  };
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setUploadedUrl("");
    setStatus("");
  };

  const handleUpload = async () => {
    if (!file) {
      setStatus("⚠️ Please select a file first.");
      return;
    }

    try {
      setLoading(true);
      setStatus("⏳ Uploading to Cloudinary...");

      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "shopPayam"); // your unsigned preset
      formData.append("folder", "myUploads"); // upload destination folder

      const response = await axios.post(
        "https://api.cloudinary.com/v1_1/dcuturlmb/upload", // replace YOUR_CLOUD_NAME
        formData
      );

      setUploadedUrl(response.data.secure_url);
      setStatus("✅ Upload successful!");
    } catch (error) {
      console.error("Upload error:", error);
      setStatus("❌ Upload failed. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",

        backgroundColor: "#f8f9fa",
      }}
    >
      <Card
        style={{
          width: "100%",
          height:"auto",
          maxWidth: "420px",
          padding: "20px",
          borderRadius: "18px",
          boxShadow: "0 4px 25px rgba(0,0,0,0.1)",
          backgroundColor: "#fff",
        }}
      >
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          Upload to Cloudinary
        </h3>

        <Form>
          <Form.Group style={{ marginBottom: "15px" }}>
            <Form.Label>Select File</Form.Label>
            <Form.Control type="file" onChange={handleFileChange} />
          </Form.Group>

          <Button
            variant="dark"
            style={{ width: "100%" }}
            onClick={handleUpload}
            disabled={loading}
          >
            {loading ? "Uploading..." : "Upload"}
          </Button>

          {uploadedUrl && (
            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <Form.Label>Uploaded File URL</Form.Label>
              <Form.Control type="text" readOnly value={uploadedUrl} />
              <Button
                variant="outline-dark"
                style={{ marginTop: "10px", width: "100%" }}
                onClick={() => navigator.clipboard.writeText(uploadedUrl)}
              >
                Copy URL
              </Button>
                                                      <Button
                      onClick={() => {
                        sendEmail();
                    
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginTop:10,
                        marginBottom: 10,
                      }}
                    >
                      Send Art Email
                    </Button>
              <div style={{ marginTop: "15px" }}>
                <img
                  src={uploadedUrl}
                  alt="Uploaded preview"
                  style={{
                    width: "100%",
                    maxHeight: "200px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    marginTop: "10px",
                  }}
                />
              </div>
            </div>
          )}

          {status && (
            <p
              style={{
                marginTop: "15px",
                textAlign: "center",
                color: status.includes("✅")
                  ? "green"
                  : status.includes("❌")
                  ? "red"
                  : "#555",
              }}
            >
              {status}
            </p>
          )}
        </Form>
      </Card>
    </div>
  );
}
